import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./i18n/i18n";
import App from './App';
import reportWebVitals from './reportWebVitals';
import LanguageProvider from './context/LanguageContext'; // Dosya yolunu kendi proje yapınıza göre düzenleyin

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById('root') // React 16'daki render yöntemi
);

// Performans ölçümü için
reportWebVitals();
